import { render, staticRenderFns } from "./SdsGhsLabelSimpleDialog.vue?vue&type=template&id=7b260f43"
import script from "./SdsGhsLabelSimpleDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsGhsLabelSimpleDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports